// extracted by mini-css-extract-plugin
export default {"largeInput":"style-module--largeInput--ahPyQ","button":"style-module--button--QObT-"};